<div class="flex justify-between gap-5">
  <div class="flex flex-col">
    <div class="flex items-center">
      <a [routerLink]="[pageReturnURL]" class="text-2xl flex-shrink-0 hover:text-primary mr-2">
        <rkt-icon name="arrow-left"></rkt-icon>
      </a>
      <h1 class="text-2xl font-bold mr-3">{{ title }}</h1>

      @if (status) {
        <app-status-tag [status]="status" />
      }
    </div>

    <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
  </div>

  <ng-content />
</div>
